// extracted by mini-css-extract-plugin
module.exports = {"banner":"FulfillmentBanner_banner__2IUEV","container":"FulfillmentBanner_container__1ae5V","button":"FulfillmentBanner_button__16HvE"};